import { render, staticRenderFns } from "./prefecture.vue?vue&type=template&id=781907b1&scoped=true&"
import script from "./prefecture.vue?vue&type=script&lang=js&"
export * from "./prefecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781907b1",
  null
  
)

export default component.exports